// Model
import { components40Names } from './components.enum';
import { RoomRulesDesign } from '../../../components/models/component-options/inline-rules.options';
import { TabSectionMode } from '../../../components/models/component-options/tabs-section.options';
import { RMCEventType } from '../../../components/common/resource-media-control/model/resource-media-control.event';
import { CaptureType } from '../../../components/common/panorama-tour/model/report-image.model';
import { FormModelType } from '../../../components/common/resource-media-control/model/resource-media.model';
// Component
import { RoomLayoutComponent } from '../../../components/common/room-layout/room-layout.component';
import { TabsSectionComponent } from '../../../components/common/tabs-section/tabs-section.component';
import { InlineRulesComponent } from '../../../components/common/inline-rules/inline-rules.component';
import { MapLocationComponent } from '../../../components/common/map-location/map-location.component';
import { PanoramaTourComponent } from '../../../components/common/panorama-tour/panorama-tour.component';
import { PhotoGalleryComponent } from '../../../components/common/photo-gallery/photo-gallery.component';
import { PhotoListSelectedComponent } from '../../../components/common/photo-list-selected/photo-list-selected.component';
import { PhotoListBulkDeleteComponent } from '../../../components/common/photo-list-bulk-delete/photo-list-bulk-delete.component';
import { ResourceMediaControlComponent } from '../../../components/common/resource-media-control/resource-media-control.component';
import { SmartTagsComponent } from '../../../components/common/smart-tags/smart-tags.component';
import { DynamicHtmlComponent } from '../../../components/common/dynamic-html/dynamic-html.component';
import { SingleImageComponent } from '../../../components/common/single-image/single-image.component';
import { GeneralPropertyDataComponent } from '../../../components/schema/v40/general-property-data/general-property-data.component';
import { GeneralOrderDataComponent } from '../../../components/schema/v40/general-order-data/general-order-data.component';
import { TabsSectionButtonComponent } from '../../../components/common/tabs-action-button/tabs-section-button.component';
import { DynamicFieldsSectionComponent } from '../../../components/common/dynamic-fields-section/dynamic-fields-section.component';

export const layout40Components = {
	[components40Names.ROOM_LAYOUT]: RoomLayoutComponent,
	[components40Names.TABS_SECTION]: TabsSectionComponent,
	[components40Names.HTML_NODE]: DynamicHtmlComponent,
	[components40Names.FIELDS_SECTION]: DynamicFieldsSectionComponent,
	[components40Names.MAP]: MapLocationComponent,
	[components40Names.RULES]: InlineRulesComponent,
	[components40Names.PANORAMA_TOUR]: PanoramaTourComponent,
	[components40Names.RESOURCE_MEDIA]: ResourceMediaControlComponent,
	[components40Names.PHOTO_GALLERY]: PhotoGalleryComponent,
	[components40Names.PHOTO_SELECTED]: PhotoListSelectedComponent,
	[components40Names.PHOTO_BULK_DELETE]: PhotoListBulkDeleteComponent,
	[components40Names.SMARTTAGS_LIST]: SmartTagsComponent,
	[components40Names.SINGLE_IMAGE]: SingleImageComponent,
	[components40Names.PROPERTY_DATA]: GeneralPropertyDataComponent,
	[components40Names.GENERAL_ORDER_DATA]: GeneralOrderDataComponent,
	[components40Names.TABS_SECTION_BUTTON]: TabsSectionButtonComponent
};

export const layout40 = {
	generalOrderData: {
		type: components40Names.ROOM_LAYOUT,
		options: {
			schemaVersion: 'v40',
			bodyCssClass: 'px-0',
			header: {
				value: 'General Order Data'
			}
		},
		items: [
			{
				type: components40Names.GENERAL_ORDER_DATA,
				options: {
					cssClass: 'h-100',
					outerCssClass: 'col has-borders border-left'
				}
			}
		]
	},
	propertyData: {
		type: components40Names.ROOM_LAYOUT,
		options: {
			schemaVersion: 'v40',
			bodyCssClass: 'px-0',
			header: {
				value: 'Property Data'
			}
		},
		items: [
			{
				type: components40Names.RULES,
				options: {
					cssClass: 'h-100',
					outerCssClass: 'col-md-3 has-borders border-left',
					layout: RoomRulesDesign.FULL_WIDTH,
					appendPathToTarget: false,
					filter: (violation: any, path: string) => {
						return (violation.targets && violation.targets.length === 0)
							|| violation.uiSection === 'PROPERTY_GENERAL_DATA';
					}
				}
			},
			{
				type: components40Names.PROPERTY_DATA,
				options: {
					cssClass: 'h-100',
					outerCssClass: 'col has-borders border-left'
				}
			}
		]
	},
	map: {
		type: components40Names.ROOM_LAYOUT,
		options: {
			schemaVersion: 'v40',
			bodyCssClass: 'container-map px-0',
			header: {
				value: 'Location'
			}
		},
		items: [
			{
				type: components40Names.MAP,
				options: {
					layout: 'v2',
					outerCssClass: 'px-0',
					filterSmartTagOptions: {
						key: 'groupName',
						value: 'location'
					}
				}
			}
		]
	},
	addressVerification: {
		type: components40Names.ROOM_LAYOUT,
		options: {
			schemaVersion: 'v40',
			cssClass: 'natural-height',
			bodyCssClass: 'px-0',
			header: {
				value: 'Address Verification'
			}
		},
		items: [
			{
				type: components40Names.RULES,
				options: {
					cssClass: 'h-100',
					outerCssClass: 'col-md-3 has-borders border-left',
					layout: RoomRulesDesign.FULL_WIDTH // @see RoomRulesDesign
				}
			},
			{
				type: components40Names.HTML_NODE,
				options: {
					outerCssClass: 'col has-borders',
					cssClass: 'row'
				},
				items: [
					{
						type: components40Names.RESOURCE_MEDIA,
						options: {
							layout: 'v2',
							groupKey: 'groupName',
							outerCssClass: 'resource-media-control'
						}
					},
					{
						type: components40Names.TABS_SECTION,
						options: {
							outerCssClass: 'col-md-7 has-borders border-left border-right',
							tabActionButtons: true
						},
						items: [
							{
								title: 'Address Verification',
								type: components40Names.PHOTO_GALLERY,
								options: {
									size: {
										width: '653px',
										height: '490px'
									},
									photosInData: false,
									showDescription: false,
									showIfEmpty: true
								}
							},
							{
								title: 'Upload Image',
								type: components40Names.TABS_SECTION_BUTTON,
								options: {
									tabSectionMode: TabSectionMode.DROPDOWN,
									dropdownOptions: [
										{
											label: 'Report Image',
											icon: 'fa-file-image',
											data: {
												eventType: RMCEventType.OPEN,
												componentData: {
													resourceMediaModel: {
														captureType: CaptureType.REPORT,
														snapshot: {
															preview: false,
															metadata: {
																photoType: 'STREET_ADDRESS'
															}
														}
													}
												}
											}
										}
									]
								}
							}
						]
					},
				]
			}
		]
	},
	generalSmartTags: {
		type: components40Names.ROOM_LAYOUT,
		options: {
			schemaVersion: 'v40',
			cssClass: 'natural-height',
			bodyCssClass: 'px-0',
			header: {
				value: 'Property Smart Tags'
			}
		},
		items: [
			{
				type: components40Names.RULES,
				options: {
					cssClass: 'h-100',
					outerCssClass: 'col-md-3 has-borders border-left',
					layout: RoomRulesDesign.FULL_WIDTH // @see RoomRulesDesign
				}
			},
			{
				type: components40Names.HTML_NODE,
				options: {
					outerCssClass: 'col has-borders',
					cssClass: 'row'
				},
				items: [
					{
						type: components40Names.RESOURCE_MEDIA,
						options: {
							layout: 'v2',
							groupKey: 'groupName',
							outerCssClass: 'resource-media-control'
						}
					},
					{
						type: components40Names.TABS_SECTION,
						options: {
							outerCssClass: 'col-md-7 has-borders border-left border-right',
							tabActionButtons: true
						},
						items: [
							{
								title: 'Selected Photos',
								type: components40Names.PHOTO_SELECTED
							},
							{
								title: 'Upload Image',
								type: components40Names.TABS_SECTION_BUTTON,
								options: {
									tabSectionMode: TabSectionMode.DROPDOWN,
									dropdownOptions: [
										{
											label: 'Smart Tags',
											icon: 'fa-tag',
											data: {
												eventType: RMCEventType.OPEN,
												componentData: {
													resourceMediaModel: {
														captureType: CaptureType.SMARTTAG,
														formModelType: FormModelType.CREATE,
														snapshot: {
															preview: false,
															metadata: {}
														}
													}
												}
											}
										},
										{
											label: 'Imageless Smart Tag',
											icon: 'fa-tag',
											data: {
												eventType: RMCEventType.OPEN,
												componentData: {
													resourceMediaModel: {
														isImageless: true,
														captureType: CaptureType.SMARTTAG,
														formModelType: FormModelType.CREATE,
														snapshot: {
															preview: false,
															metadata: {}
														}
													}
												}
											}
										}
									]
								}
							}
						]
					},
					{
						type: components40Names.SMARTTAGS_LIST,
						options: {
							outerCssClass: 'col-md-5 has-borders border-right',
							key: 'smartTags',
							groupKey: 'groupName',
							version: 'v2',
							exclude: ['location', 'LOCATION']
						}
					}
				]
			}
		]
	},
	level: {
		type: components40Names.ROOM_LAYOUT,
		options: {
			schemaVersion: 'v40',
			bodyCssClass: 'px-0',
			header: {
				key: 'cv_Label'
			}
		},
		items: [
			{
				type: components40Names.RULES,
				options: {
					cssClass: 'h-100',
					outerCssClass: 'col-md-3 has-borders border-left',
					layout: RoomRulesDesign.FULL_WIDTH // @see RoomRulesDesign
				}
			},
			{
				type: components40Names.HTML_NODE,
				options: {
					outerCssClass: 'col has-borders',
					cssClass: 'row'
				},
				items: [
					{
						type: components40Names.RESOURCE_MEDIA,
						options: {
							layout: 'v2',
							groupKey: 'groupName',
							outerCssClass: 'resource-media-control'
						}
					},
					{
						type: components40Names.TABS_SECTION,
						options: {
							outerCssClass: 'col-md-7 has-borders border-left border-right',
							tabActionButtons: true
						},
						items: [
							{
								title: 'Floorplan',
								type: components40Names.PHOTO_GALLERY,
								options: {
									size: {
										width: '653px',
										height: '490px'
									},
									showDescription: true,
									filter: ['GLA'],
									readDescriptionFromData: {
										key: [
											'description',
											'roomId'
										]
									},
									showIfEmpty: true
								}
							},
							{
								title: 'Selected Photos',
								type: components40Names.PHOTO_SELECTED
							},
							{
								title: 'Upload Image',
								type: components40Names.TABS_SECTION_BUTTON,
								options: {
									tabSectionMode: TabSectionMode.DROPDOWN,
									dropdownOptions: [
										{
											label: 'Smart Tags',
											icon: 'fa-tag',
											data: {
												eventType: RMCEventType.OPEN,
												componentData: {
													resourceMediaModel: {
														captureType: CaptureType.SMARTTAG,
														formModelType: FormModelType.CREATE,
														snapshot: {
															preview: false,
															metadata: {}
														}
													}
												}
											}
										},
										{
											label: 'Imageless Smart Tag',
											icon: 'fa-tag',
											data: {
												eventType: RMCEventType.OPEN,
												componentData: {
													resourceMediaModel: {
														isImageless: true,
														captureType: CaptureType.SMARTTAG,
														formModelType: FormModelType.CREATE,
														snapshot: {
															preview: false,
															metadata: {}
														}
													}
												}
											}
										}
									]
								}
							}
						]
					},
					{
						type: components40Names.SMARTTAGS_LIST,
						options: {
							outerCssClass: 'col-md-5 has-borders border-right',
							key: 'smartTags',
							groupKey: 'groupName',
							version: 'v2'
						}
					}
				]
			}
		]
	},
	room: {
		type: components40Names.ROOM_LAYOUT,
		options: {
			schemaVersion: 'v40',
			bodyCssClass: 'px-0',
			header: { key: 'title' }
		},
		items: [
			{
				type: components40Names.HTML_NODE,
				options: {
					outerCssClass: 'col-md-3 has-borders border-left',
				},
				items: [
					{
						type: components40Names.FIELDS_SECTION,
						title: 'Room information',
						options: {
							appendPath: true,
						},
						items: [
							[
								{
									path: 'cv_ConditionRate',
									title: 'AI provided Condition Rating'
								},
								{
									path: 'cv_Status',
									title: 'AI provided Room Status'
								}
							]
						]
					},
					{
						type: components40Names.RULES,
						options: {
							cssClass: 'h-100',
							layout: RoomRulesDesign.FULL_WIDTH
						}
					}
				]
			},
			{
				type: components40Names.HTML_NODE,
				options: {
					outerCssClass: 'col has-borders',
					cssClass: 'row'
				},
				items: [
					{
						type: components40Names.RESOURCE_MEDIA,
						options: {
							layout: 'v2',
							groupKey: 'groupName',
							outerCssClass: 'resource-media-control'
						}
					},
					{
						type: components40Names.TABS_SECTION,
						options: {
							outerCssClass: 'col-md-7 has-borders border-left border-right',
							tabActionButtons: true
						},
						items: [
							{
								title: 'Report Images',
								type: components40Names.PHOTO_GALLERY,
								options: {
									size: {
										width: '653px',
										height: '490px'
									},
									showDescription: true,
									filter: ['HDR'],
									readDescriptionFromData: {
										key: [
											'description',
											'roomId'
										]
									},
									showIfEmpty: true
								}
							},
							{
								title: '3d Tour',
								type: components40Names.PANORAMA_TOUR,
								options: {
									filter: ['EQUIRECTANGULAR'],
									readDescriptionFromData: {
										key: [
											'description',
											'roomId'
										]
									}
								}
							},
							{
								title: 'Bulk Delete',
								type: components40Names.PHOTO_BULK_DELETE,
								options: {
									label: 'Select all the photos you want to delete',
									filter: ['HDR'],
									showIfEditMode: true
								}
							},
							{
								title: 'Selected Photos',
								type: components40Names.PHOTO_SELECTED
							},
							{
								title: 'Upload Image',
								type: components40Names.TABS_SECTION_BUTTON,
								options: {
									tabSectionMode: TabSectionMode.DROPDOWN,
									dropdownOptions: [
										{
											label: 'Report Image',
											icon: 'fa-file-image',
											data: {
												eventType: RMCEventType.OPEN,
												componentData: {
													resourceMediaModel: {
														captureType: CaptureType.REPORT,
														snapshot: {
															preview: false,
															metadata: {}
														}
													}
												}
											}
										},
										{
											label: 'Smart Tags',
											icon: 'fa-tag',
											data: {
												eventType: RMCEventType.OPEN,
												componentData: {
													resourceMediaModel: {
														captureType: CaptureType.SMARTTAG,
														formModelType: FormModelType.CREATE,
														snapshot: {
															preview: false,
															metadata: {}
														}
													}
												}
											}
										},
										{
											label: 'Imageless Smart Tag',
											icon: 'fa-tag',
											data: {
												eventType: RMCEventType.OPEN,
												componentData: {
													resourceMediaModel: {
														isImageless: true,
														captureType: CaptureType.SMARTTAG,
														formModelType: FormModelType.CREATE,
														snapshot: {
															preview: false,
															metadata: {}
														}
													}
												}
											}
										}
									]
								}
							}
						]
					},
					{
						type: components40Names.SMARTTAGS_LIST,
						options: {
							outerCssClass: 'col-md-5 has-borders border-right',
							key: 'smartTags',
							groupKey: 'groupName',
							version: 'v2'
						}
					}
				]
			}
		]
	}
};
